// Heading and body copy: px-8 on mobile (matching the hero's own text inset
// there), flush left from md: up — same treatment as ExpertCards' heading,
// so every headline and copy block on the page lines up with the hero
// image/card grid's left edge on desktop, per Charly's latest ask. Copy
// rewritten per Charly (18 Sept), replacing the original two lines.
export function OnTheDay() {
    return (
        <section className="px-8 pt-section-gap md:px-0">
            <h2 className="pb-section-headline-gap-bottom text-2xl font-medium text-unimo-slate lg:text-3xl">
                How does this work?
            </h2>
            <p className="font-light text-unimo-slate">
                Simply head to stand K1 five minutes before your meeting time and ask for them by name.
            </p>
            {/* Same size as the rest of the page's body copy now — was text-sm, per Charly's correction. */}
            <p className="mt-2 font-light text-unimo-site-grey-700">
                We know events like this can get chaotic at times. If your timings shift, or if something else
                lands in the diary, please cancel or reschedule using the link in your calendar.
            </p>
        </section>
    )
}

export default OnTheDay
